import { DatastoreProxy } from "../interface/DatastoreProxy";
import { IdPathBuilder } from "../navigation/IdPathBuilder";

export async function entryExists(id: IdPathBuilder): Promise<boolean> {
	const result = await DatastoreProxy.instance.collectionQuery({
		"context node path": id.build(),
		"select entries": "no",
		"collection path": {
			"has steps": "no",
		},
		aggregates: {},
		filters: {
			"value filters": {},
			"todo filter": "no",
		},
	});
	switch (result.properties.context.state.name) {
		case "does not exist":
			return false;
		case "exists":
			return true;
		case "permission denied":
			return false;
		default:
			unexpectedState(result.properties.context.state);
	}
}
